import React, { useState, useEffect } from "react";
import { ThemeContext, themes } from "contexts/ThemeContext";

const THEME_STORAGE_KEY = "userThemePreference";

export default function ThemeContextWrapper(props) {
  // Load theme from localStorage or default to dark
  const getInitialTheme = () => {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
      if (
        savedTheme &&
        (savedTheme === themes.light || savedTheme === themes.dark)
      ) {
        return savedTheme;
      }
    }
    return themes.dark;
  };

  const [theme, setTheme] = useState(getInitialTheme);

  function changeTheme(newTheme) {
    setTheme(newTheme);
    // Save to localStorage
    if (typeof window !== "undefined") {
      localStorage.setItem(THEME_STORAGE_KEY, newTheme);
    }
  }

  useEffect(() => {
    switch (theme) {
      case themes.light:
        document.body.classList.add("white-content");
        break;
      case themes.dark:
      default:
        document.body.classList.remove("white-content");
        break;
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme: theme, changeTheme: changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}
